import React from 'react';
import { string } from 'prop-types';

import { BQLink } from '../../atoms/bqlink';
import BookmarkIcon from '../../atoms/icons/bookmark';
import SectionHeaderTitle from '../../atoms/section-header-title';

const sectionTitle = (props) => {
  const { iconCode,height, iconSize = 'base-medium', iconColor = 'sixth-color' } = props;
  return (
    <SectionHeaderTitle {...props}>
      {iconCode ? (
        <i
          className={iconCode}
          style={{
            fontSize: `var(--${iconSize})`,
            color: `var(--${iconColor})`,
            marginRight: '8px',
          }}
        />
      ) : (
        <BookmarkIcon fontSize={height} color="sixth-color" />
      )}
    </SectionHeaderTitle>
  );
};

const GenericTitle = ({ width, height, href, iconCode, iconSize, iconColor, ...props }) => (
  <>
  {href ? (
    <BQLink href={href}>{sectionTitle({ ...props, iconCode, iconSize, iconColor })}</BQLink>
  ) : (
    <>{sectionTitle({ ...props, iconCode, iconSize, iconColor })}</>
  )}
</>
);

GenericTitle.propTypes = {
  width: string,
  height: string,
  href: string,
  iconCode: string,
  iconSize: string,
  iconColor: string,
};

export default GenericTitle;
